import styledComponents from "styled-components";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

export const HeadingPrimary = styledComponents.h1`
    font-weight: 700;
    color: ${({ theme }) => theme.text};
    letter-spacing: -0.5px;
    font-size: 5.2rem;
    line-height: 1.05;
    margin-bottom: 3.2rem;
`;

export const Paragraph = styledComponents.p`
  color: ${({ theme }) => theme.text};
  font-size: 2rem;
  line-height: 1.6;
  padding-top: 1rem;
`;

export const SectionWrapper = styledComponents.p`
  padding-bottom: 9.6rem;
`;

export const ParagraphSlant = styledComponents.p`
  color: ${({ theme }) => theme.text};
  font-size: 2rem;
  line-height: 1.6;
  padding-top: 1rem;
  font-style: italic;
`;

export const NumberedList = styledComponents.ol`
  color: ${({ theme }) => theme.text};
  font-size: 2rem;
  line-height: 1.6;
  padding-top: 2rem;
  padding-bottom: 2rem;
  li {
    padding-bottom: 1.5rem;
  }
`;

export const BulletList = styledComponents.ul`
  color: ${({ theme }) => theme.text};
  font-size: 2rem;
  line-height: 1.6;
  padding-top: 2rem;
  padding-bottom: 2rem;
  li {
    padding-bottom: 1.5rem;
  }
`;

export const Caption = styledComponents.p`
font-weight: 700;
  color: ${({ theme }) => theme.text};
  font-size: 1.8rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

export const Heading = styledComponents.h2`
  font-weight: 700;
  color: ${({ theme }) => theme.text};
  letter-spacing: -0.5px;
  font-size: 4.4rem;
  line-height: 1.2;
  margin-bottom: 6rem;
`;

export const SubHeading = styledComponents.h3`
  font-weight: 700;
  color: ${({ theme }) => theme.text};
  letter-spacing: -0.5px;
  font-size: 3.2rem;
  line-height: 1.2;
  margin-top: 4rem;
  margin-bottom: 3rem;
`;

export const SubHeading2 = styledComponents.h3`
  font-weight: 700;
  color: ${({ theme }) => theme.text};
  letter-spacing: -0.5px;
  font-size: 2.2rem;
  line-height: 1.2;
  margin-top: 4rem;
  margin-bottom: 3rem;
`;

export const HeadingSecondary = styledComponents.h2`
    font-weight: 700;
    color: ${({ theme }) => theme.text};
    letter-spacing: -0.5px;
    font-size: 4.4rem;
    line-height: 1.2;
    margin-bottom: 8rem;
`;

export const HeadingTertiary = styledComponents.h2`
    font-weight: 700;
    color: ${({ theme }) => theme.text};
    letter-spacing: -0.5px;
    font-size: 4.4rem;
    line-height: 1.2;
    margin-bottom: 8rem;
`;

export const Container = styledComponents.div`
  max-width: 120rem;
  padding: 0 3.2rem;
  margin: 0 auto;
`;

export const Button = styledComponents.a`
    &,
    &:link, 
    &:visited {
        display: inline-block;
        text-decoration: none;
        font-size: 1.8rem;
        font-weight: 500;
        padding: 1.6rem 3.2rem;
        border-radius: 9px;
        border: none;
        cursor: pointer;
        font-family: inherit;
        transition: all 0.3s;
    }
`;

export const ButtonFull = styledComponents(Button)`
    &:link, &:visited {
        background-color: ${({ theme }) => theme.background};
        color: #fff;
    }
    &:hover, &:active {
        background-color: ${({ theme }) => theme.primary};
    }
    margin-right: ${(props) => (props.margin ? "1.6rem" : "0")};
`;

export const ButtonOutline = styledComponents(Button)`
    &:link, &:visited {
        background-color: #fff;
        color: #555;
        border: 2px solid ${({ theme }) => theme.background};
    }
    margin-right: ${(props) => (props.margin ? "1.6rem" : "0")};
`;

export const ModeUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));
